import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CloseOutlined } from 'jl-design-system/components/icons/CloseOutlined';

import styles from './typeahead-overlay.scss';

export const CloseButton = ({
  isTypeaheadOpen,
  onCloseButtonClick,
  isDesktopCloseButton,
  onTabOut = () => {},
}) => {
  const closeButtonClasses = classNames([styles.bpCloseButton], {
    [styles.bpCloseButton__hidden]: !isTypeaheadOpen,
    [styles.bpCloseButton__desktop]: isDesktopCloseButton,
    [styles.bpCloseButton__mobile]: !isDesktopCloseButton,
  });

  return (
    <button
      data-testid={`close-expanded-search-${
        isDesktopCloseButton ? 'desktop' : 'mobile'
      }`}
      className={closeButtonClasses}
      onClick={onCloseButtonClick}
      onBlur={onTabOut}
    >
      <CloseOutlined className={styles.closeIcon} size="medium" />
      <span>Close</span>
    </button>
  );
};

CloseButton.propTypes = {
  isTypeaheadOpen: PropTypes.bool.isRequired,
  onCloseButtonClick: PropTypes.func.isRequired,
  isDesktopCloseButton: PropTypes.bool.isRequired,
  onTabOut: PropTypes.func,
};
